<template>
    <div>
        <div style="padding: 0 20px">
            <!--    新增角色按钮-->
            <div class="top" style="justify-content: space-between">
                <div>
                    
                    <el-input v-model="query.medicinalName"
                              size="small"
                              placeholder="药品名称/通用名"
                              suffix-icon="el-icon-search"
                              style="width: 160px;margin-left: 20px">
                    </el-input>
                    <el-select  v-model="query.medicinalParentType" @change="chooseParentType" size="small" style="width: 160px;margin-left: 20px">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in typeList" :key="item.typeCode"
                                    :label="item.typeName" :value="item.typeCode"></el-option>
                    </el-select>
                    <el-select  v-model="query.medicinalType" size="small" style="width: 160px;margin-left: 20px">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in typeDetailList" :key="item.typeCode"
                                    :label="item.typeName" :value="item.typeCode"></el-option>
                    </el-select>
                    
                    <el-button type="primary" @click="search" style="width: 68px;margin-left: 20px">查询</el-button>
                   <el-button type="primary" @click="openAdd" style="width: 68px;">新增</el-button>
                </div>
                <div style="display:flex">
                   <el-button size="small" style="width: 96px;float:right;margin-right:10px" @click="excelExport">下载模板</el-button>                   
                   <el-button size="small" style="width: 96px;float:left;margin-right:10px" @click="openPicImport">图片批量导入</el-button> 
                   <el-upload
                    style="display: inline-block; margin-left:10px;margin-right:10px;width:100px;float:right;" 
                    action=""
                    :multiple="false"
                    :limit=1                    
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :show-file-list="false"
                    :drag="false"
                    :http-request="uploadFile"
                    ref="excel"
                    >
                    <el-button size="small" style="width: 96px;float:left">批量导入</el-button>
                    </el-upload>                
                    
                </div>
            </div>
            <!--    角色信息表格-->
            <div>
                <el-table :data="tableData" v-loading="loading">
             
                    <el-table-column label="药品名称" prop="productName"></el-table-column>                   
                    <el-table-column label="药品分类" prop="productTypeName"></el-table-column>
                    <el-table-column label="所属类别" prop="productSubTypeName"></el-table-column>
                    <el-table-column label="规格"     prop="specification"></el-table-column>            
                    
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editMedicinal(scope.row)">编辑</el-button>                            
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增" :visible.sync="dialogAddVisible" width="760px" :close-on-click-modal="false">
        
            <el-form :model="medicinalAdd" label-width="100px" size="small" :rules="rule" ref="add" style="margin-top: 20px">
                <el-card class="box-card">
                     <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="药品分类:" prop="productType">
                            <el-select  v-model="medicinalAdd.productType" @change="chooseParentType" size="small" style="width: 240px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option v-for="item in typeList" :key="item.typeCode"
                                            :label="item.typeName" :value="item.typeCode"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属类别:" prop="productSubType">
                            <el-select  v-model="medicinalAdd.productSubType" size="small" style="width: 240px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option v-for="item in typeDetailList" :key="item.typeCode"
                                            :label="item.typeName" :value="item.typeCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="药品名称:" prop="productName">
                            <el-input v-model="medicinalAdd.productName" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="拼音简码:" prop="productPrefix">
                            <el-input v-model="medicinalAdd.productPrefix" style="width: 240px"></el-input>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">                        
                        <el-form-item label="药品规格:" prop="specification">
                            <el-input v-model="medicinalAdd.specification" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="药品条形码:" prop="productBarCode">
                            <el-input v-model="medicinalAdd.productBarCode" style="width: 240px"></el-input>                
                        </el-form-item>
                    </div>
             
                    <div class="dialog-set">                        
                        <el-form-item label="生产厂家:" prop="manufacturer">
                            <el-input v-model="medicinalAdd.manufacturer" style="width: 240px"></el-input>
                        </el-form-item>
                         <el-form-item label="批注文号:" prop="referenceNumber">
                            <el-input v-model="medicinalAdd.referenceNumber" style="width: 240px"></el-input>
                        </el-form-item>    
                    </div>

                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>用药信息</span>
                    </div>
                    <div class="dialog-set">             
                    
                     <el-form-item label="频率:" prop="frequency">
                        <el-select v-model="medicinalAdd.frequency" style="width: 240px" >
                            <el-option  label="一日一次" value="BID"></el-option>                            
                            <el-option  label="一日三次" value="QD"></el-option>
                        </el-select>
                    </el-form-item>
                    </div>
                    <div class="dialog-set">
                    <el-form-item label="单次剂量:" prop="dosageCount">
                        <el-input v-model="medicinalAdd.dosageCount" style="width: 240px" ></el-input>
                    </el-form-item>
                    <el-form-item label="剂量单位:" prop="oneUnit">
                        <el-select v-model="medicinalAdd.oneUnit" style="width: 240px">
                             <el-option  label="片" value="PIAN"></el-option>                            
                             <el-option  label="克" value="KE"></el-option>
                        </el-select>
                    </el-form-item>
                    </div>
                    <div class="dialog-set">
                    <el-form-item label="天数:" prop="dosageDays">
                        <el-input v-model="medicinalAdd.dosageDays" style="width: 240px"></el-input>
                    </el-form-item> 
                     <el-form-item label="用法:" prop="dosageUsage">
                        <el-select v-model="medicinalAdd.dosageUsage" style="width: 240px">
                            <el-option  label="口服" value="PO"></el-option>
                            <el-option  label="空腹口服" value="41"></el-option>
                            <el-option  label="餐前服用" value="42"></el-option>
                        </el-select>
                    </el-form-item>
                    
                </div>
                 <div class="dialog-set">                   
                    <el-form-item label="使用说明:" prop="productUsage">
                        <el-input v-model="medicinalAdd.productUsage" style="width: 500px"></el-input>
                    </el-form-item>                    
                </div>
                </el-card>
       
               <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>产品图片</span>
                    </div>
                    <div class="dialog-set">
                     <el-form-item label="产品主图:" prop="mainPic">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="medicinalAdd.mainPic"  class="course-img" :src="medicinalAdd.mainPic"></el-image>
                            <input type="file" class="upload-input" @change="addMainImg" accept="image/*" ref="mainPic"/>
                        </div>      
                    </el-form-item>
                     <el-form-item label="产品说明书:" prop="detailPic">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="medicinalAdd.detailPic"  class="course-img" :src="medicinalAdd.detailPic"></el-image>
                            <input type="file" class="upload-input" @change="addDetailImg" accept="image/*" ref="detailPic"/>
                        </div>      
                    </el-form-item>
                    </div>

               </el-card>    

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAdd">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑药材" :visible.sync="dialogEditVisible" width="740px" :close-on-click-modal="false">
           
            <el-form :model="medicinalEdit" label-width="100px" size="small" :rules="rule" ref="edit" style="margin-top: 20px">
                <el-card class="box-card">
                     <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="药品分类:" prop="productType">
                            <el-select  v-model="medicinalEdit.productType" @change="chooseParentType" size="small" style="width: 240px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option v-for="item in typeList" :key="item.typeCode"
                                            :label="item.typeName" :value="item.typeCode"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属类别:" prop="productSubType">
                            <el-select  v-model="medicinalEdit.productSubType" size="small" style="width: 240px;">
                                <el-option key="" label="全部" value=""></el-option>
                                <el-option v-for="item in typeDetailList" :key="item.typeCode"
                                            :label="item.typeName" :value="item.typeCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        <el-form-item label="药品名称:" prop="productName">
                            <el-input v-model="medicinalEdit.productName" :disabled="true" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="拼音简码:" prop="productPrefix">
                            <el-input v-model="medicinalEdit.productPrefix" style="width: 240px"></el-input>
                        </el-form-item>
                    </div>
                    <div class="dialog-set">
                        
                        <el-form-item label="药品规格:" prop="specification">
                            <el-input v-model="medicinalEdit.specification" style="width: 240px"></el-input>
                        </el-form-item>
                        <el-form-item label="药品条形码:" prop="productBarCode">
                            <el-input v-model="medicinalEdit.productBarCode" style="width: 240px"></el-input>                
                        </el-form-item>
                    </div>           
                    <div class="dialog-set">                        
                        <el-form-item label="生产厂家:" prop="manufacturer">
                            <el-input v-model="medicinalEdit.manufacturer" style="width: 240px"></el-input>
                        </el-form-item>
                         <el-form-item label="批注文号:" prop="referenceNumber">
                            <el-input v-model="medicinalEdit.referenceNumber" style="width: 240px"></el-input>
                        </el-form-item>    
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>用药信息</span>
                    </div>
                    <div class="dialog-set">     
                    
                     <el-form-item label="频率:" prop="frequency">
                        <el-select v-model="medicinalEdit.frequency" style="width: 240px" >
                            <el-option  label="一日一次" value="BID"></el-option>                            
                            <el-option  label="一日三次" value="QD"></el-option>
                        </el-select>
                    </el-form-item>
                    </div>
                    <div class="dialog-set">
                    <el-form-item label="单次剂量:" prop="dosageCount">
                        <el-input v-model="medicinalEdit.dosageCount" style="width: 240px" ></el-input>
                    </el-form-item>
                    <el-form-item label="剂量单位:" prop="oneUnit">
                        <el-select v-model="medicinalEdit.oneUnit" style="width: 240px">
                             <el-option  label="片" value="PIAN"></el-option>                            
                             <el-option  label="克" value="KE"></el-option>
                        </el-select>
                    </el-form-item>
                    </div>
                    <div class="dialog-set">
                    <el-form-item label="天数:" prop="dosageDays">
                        <el-input v-model="medicinalEdit.dosageDays" style="width: 240px"></el-input>
                    </el-form-item> 
                     <el-form-item label="用法:" prop="dosageUsage">
                        <el-select v-model="medicinalEdit.dosageUsage" style="width: 240px">
                            <el-option  label="口服" value="PO"></el-option>
                            <el-option  label="空腹口服" value="41"></el-option>
                            <el-option  label="餐前服用" value="42"></el-option>
                        </el-select>
                    </el-form-item>
                    
                </div>
                 <div class="dialog-set">                   
                    <el-form-item label="使用说明:" prop="productUsage">
                        <el-input v-model="medicinalEdit.productUsage" style="width: 500px"></el-input>
                    </el-form-item>                    
                </div>
                </el-card>
              
               <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>产品图片</span>
                    </div>
                    <div class="dialog-set">
                     <el-form-item label="产品主图:" prop="mainPic">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="medicinalEdit.mainPic"  class="course-img" :src="medicinalEdit.mainPic"></el-image>
                            <input type="file" class="upload-input" @change="editMainImg" accept="image/*" ref="mainPic"/>
                        </div>      
                    </el-form-item>
                     <el-form-item label="产品说明书:" prop="detailPic">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="medicinalEdit.detailPic"  class="course-img" :src="medicinalEdit.detailPic"></el-image>
                            <input type="file" class="upload-input" @change="editDetailImg" accept="image/*" ref="detailPic"/>
                        </div>      
                    </el-form-item>
                    </div>
               </el-card>              
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmEdit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="添加产品图片文件夹" :visible.sync="dialogPicVisible" width="540px" :close-on-click-modal="false">
             <el-form :model="picFolder" label-width="120px">
                <el-form-item label="图片文件夹">      
                    <input type="file" ref="picFolder" hidden @change.stop="folderChange" webkitdirectory/>              
                    <el-input placeholder="请输入文件夹地址" v-model="picFolder.folderPath" class="input-with-select">
                    <el-button slot="append" icon="el-icon-folder" type="success" @click="btnChange"></el-button>
                    </el-input>
                </el-form-item>
             </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="dialogPicVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadFolder">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 搜索数据
                query: {                   
                   medicinalParentType:'',
                   medicinalType:''
                },
                dialogPicVisible:false,
                picFolder: {
                    folderPath: ''
                },
                fileList:[],
                // 表格页
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // loading
                loading: true,
                // 列表数据
                tableData: [],
                // medicinesDosage: [],               
                // 产品类别
                typeList: [],
                // 次级分类
                typeDetailList: [],                
                // 新增弹窗
                dialogAddVisible: false,
                // 表单验证
                rule:{
                    productName:[{required: true, message: '请输入药品名称', trigger: 'blur'}],                                   
                    productType: [{required: true, message: '请选择药品类别', trigger: 'change'}],
                    productSubType: [{required: true, message: '请选择所属类别', trigger: 'change'}],     
                    
                },
                medicinalAdd: {
                    // 药品剂型 颗粒饮片1
                    productType: '',
                    productSubType:'',
                    // 药品名称1
                    productName: '',                   
                    // 药品简码1
                    productPrefix: '',                   
                    specification: '',             
                   
                    // 药品条形码
                    productBarCode: '',
                    // 药品批注文号
                    referenceNumber: '',
                    // 药品厂家
                    manufacturer: '',
                    
                    // 制剂单位
                    oneUnit: '',
                    //制剂数量
                    dosageCount: '',
                    // 用法
                    dosageUsage: '',
                    // 频率
                    frequency: '',
                    // 剂量
                    dosage: '',
                    dosageDays:'',
                    productUsage:'',                   
                },
                dialogEditVisible: false,
                medicinalEdit: {                    
                    productNo :'',                    
                    // 药品剂型 颗粒饮片1
                    productType: '',
                    productSubType:'',
                    // 药品名称1
                    productName: '',                   
                    // 药品简码1
                    productPrefix: '',                    
                    specification: '',                    
                    // 药品次级类别
                    productSubTypeSub: '',
                    // 药品条形码
                    productBarCode: '',
                    // 药品批注文号
                    referenceNumber: '',
                    // 药品厂家
                    manufacturer: '',
                    
                    // 制剂单位
                    oneUnit: '',
                    //制剂数量
                    dosageCount: '',
                    // 用法
                    dosageUsage: '',
                    // 频率
                    frequency: '',
                    // 剂量
                    dosage: '',
                    dosageDays:'',
                    productUsage:'',                

                }
            }
        },
        methods: {
           
            search(){
                this.getData();
            },
            // 获取列表数据
            getData() {
                this.loading = true
                let params = {
                    
                    medicinalParentType:this.query.medicinalParentType,
                    medicinalType:this.query.medicinalType,
                    medicinalName: this.query.medicinalName,
                }               
                this.axios.post('/api-b/10050/100165/' + this.pageNum + '/' + this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total
                        } else {
                            this.$message.info('暂无药材')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            openPicImport(){
                this.dialogPicVisible = true
            },
            // 打开新增
            openAdd() {
                this.dialogAddVisible = true
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                    this.medicinalAdd.productType = this.query.medicinalParentType
                    this.chooseParentType(this.query.medicinalParentType)
                })
            },
           
            // 获取产品类别
            getParentType() {                
                this.axios.get('/api-b/10038/100166',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.typeList = res.data.data
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(() => {})
            },
            // 选择产品类别
            chooseParentType(val) {
           
                this.axios.get('/api-b/10039/100149?parentCode='+val,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.typeDetailList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 选择制剂单位
            selectOneUnit(val) {
                this.oneUnit = this.oneUnitList.find(item => {
                    return item.value === val
                }).label
            },
            uploadImg(data) {
                return new Promise(resolve => {
                    this.axios.post('/api-f/10027/100065',data,{
                        headers:{
                            Authorization: this.authorization,
                            'Content-Type':'multipart/form-data'
                        }
                    }).then(res => {
                        resolve(res)
                    })
                })
            },
            addMainImg(){
                let inputDOM = this.$refs.mainPic;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'product')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.medicinalAdd.mainPic = res.data.data.filePath
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            addDetailImg(){
                let inputDOM = this.$refs.detailPic;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'product')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.medicinalAdd.detailPic = res.data.data.filePath
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            editMainImg(){
                let inputDOM = this.$refs.mainPic;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'product')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.medicinalEdit.mainPic = res.data.data.filePath
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            editDetailImg(){
                let inputDOM = this.$refs.detailPic;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                params.append("pathPrefix",'product')
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.medicinalEdit.detailPic = res.data.data.filePath
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确认新增
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {}                       
                        params = {                           
                            productType:this.medicinalAdd.productType,
                            productSubType:this.medicinalAdd.productSubType,                   
                            // 药品名称1
                            productName: this.medicinalAdd.productName,                           
                            // 药品简码1
                            productPrefix: this.medicinalAdd.productPrefix,
                            specification: this.medicinalAdd.specification,                            
                            productSubTypeSub: this.medicinalAdd.productSubTypeSub,
                            productBarCode: this.medicinalAdd.productBarCode,
                            manufacturer: this.medicinalAdd.manufacturer,
                            referenceNumber: this.medicinalAdd.referenceNumber,
                            frequency: this.medicinalAdd.frequency,
                            dosageCount: this.medicinalAdd.dosageCount,
                            oneUnit: this.medicinalAdd.oneUnit,                            
                            dosageUsage: this.medicinalAdd.dosageUsage,
                            dosageDays: this.medicinalAdd.dosageDays,
                            productUsage: this.medicinalAdd.productUsage,
                            mainPic: this.medicinalAdd.mainPic,
                            detailPic: this.medicinalAdd.detailPic,                            
                        }
                        
                        this.axios.post('/api-b/10050/100085/',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                })
                            } else  {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                })
            },
            // 获取药材详情,打开编辑
            editMedicinal(data) {
                let params = new FormData()
                params.append('productNo',data.productNo)
                this.axios.post('/api-b/10050/100087/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.medicinalEdit = res.data.data               
                        this.dialogEditVisible = true
                        this.getParentType()
                        this.chooseParentType(this.medicinalEdit.productType)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            // 编辑弹窗选择制剂单位
            editSelectProductType(val) {
                this.editOneUnit = this.oneUnitList.find(item => {
                    return item.value === val
                }).label
            },
            // 确认编辑
            confirmEdit() {
                let params = {}
               
                params = {
                   
                    productNo :this.medicinalEdit.productNo,
                    
                    productType:this.medicinalEdit.productType,
                    productSubType:this.medicinalEdit.productSubType,                   
                    // 药品名称1
                    productName: this.medicinalEdit.productName,
                    
                    // 药品简码1
                    productPrefix: this.medicinalEdit.productPrefix,
                    specification: this.medicinalEdit.specification,
                                  
                   
                    productSubTypeSub: this.medicinalEdit.productSubTypeSub,
                    productBarCode: this.medicinalEdit.productBarCode,
                    manufacturer: this.medicinalEdit.manufacturer,
                    referenceNumber: this.medicinalEdit.referenceNumber,
                    frequency: this.medicinalEdit.frequency,
                    dosageCount: this.medicinalEdit.dosageCount,
                    oneUnit: this.medicinalEdit.oneUnit,                            
                    dosageUsage: this.medicinalEdit.dosageUsage,
                    dosageDays: this.medicinalEdit.dosageDays,
                    productUsage: this.medicinalEdit.productUsage,
                    mainPic: this.medicinalEdit.mainPic,
                    detailPic: this.medicinalEdit.detailPic,
                   
                }
                
                this.axios.post('/api-b/10050/100086/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
           
             excelExport(){
               this.axios.get('/api-b/10050/100213',{
                    headers:{
                        Authorization: this.authorization
                    }, responseType: "blob"
                }).then(response => {                   
                        const BLOB = response.data;
                        const headers = response.headers
                        this.fileName = JSON.parse(JSON.stringify(headers));
                        let arr = this.fileName["content-type"].split(";");
                        this.fileName = arr[1];     
                        let ar = this.fileName.split("=");
                        this.fileName = ar[1];                   
                        // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB);
                        // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = revertUTF8(this.fileName);
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                    
                })
            },
            uploadFile(item){            
                let params = new FormData()
                params.append('file',item.file)
                
                this.axios.post('/api-b/10050/100215',params,{
                        headers:{
                            Authorization: this.authorization,
                            'Content-Type':'multipart/form-data'
                        }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()                        
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },
            folderChange() {
                console.log(this.$refs.picFolder.files)
                this.fileList = this.$refs.picFolder.files          
             },
            btnChange() {
                var file = this.$refs.picFolder
                file.click()
            },
            uploadFolder(){            
                let params = new FormData()
                for (let i = 0; i < this.fileList.length; i++) {  // 每个file append到formdata里
                    params.append('file', this.fileList[i])
                }              
                                  
                this.axios.post('/api-b/10050/100216',params,{
                        headers:{
                            Authorization: this.authorization,
                            'Content-Type':'multipart/form-data'
                        }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogPicVisible = false
                        this.getData()                        
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },
            
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep:true
            }
        },
        created() {            
            this.getParentType()
            this.getData()           
            
        }
    }
    function revertUTF8(szInput) {
    var x,wch,wch1,wch2,uch="",szRet="";
    for (x=0; x<szInput.length; x++) {
        if (szInput.charAt(x)=="%") {
            wch =parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
            if (!wch) {break;}
            if (!(wch & 0x80)) {
                wch = wch;
            } else if (!(wch & 0x20)) {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x1F)<< 6;
                wch1 = wch1 & 0x3F;
                wch  = wch + wch1;
            } else {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                x++;
                wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                wch  = (wch & 0x0F)<< 12;
                wch1 = (wch1 & 0x3F)<< 6;
                wch2 = (wch2 & 0x3F);
                wch  = wch + wch1 + wch2;
            }
            szRet += String.fromCharCode(wch);
        } else {
            szRet += szInput.charAt(x);
        }
    }
    return(szRet);
}
function getFullPath(obj)
{
if(obj)
{
//ie
if (window.navigator.userAgent.indexOf("MSIE")>=1)
{
obj.select();
return document.selection.createRange().text;
}
//firefox
else if(window.navigator.userAgent.indexOf("Firefox")>=1)
{
if(obj.files)
{
return obj.files.item(0).getAsDataURL();
}
return obj.value;
}
return obj.value;
}
}
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-upload{
        border: none!important;
    }
    .el-upload--text {
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height:36px;
        margin-top: -25px;
        font-size: 14px
    }
    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: center
    }
    .active{
        box-shadow: 0 2px 0 rgba(97,167,255,1);
        color:rgba(97,167,255,1);
    }
     .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
     .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>